import React from 'react';

import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

interface InformationFieldProps {
  label: string;
  value?: string | number | null;
  align?: 'left' | 'center' | 'right';
}

const InformationField: React.FunctionComponent<InformationFieldProps> = (props) => {
  const { label, value, align } = props;

  return (
    <Grid container>
      <Grid item xs={6} md={12}>
        <Typography variant="subtitle1" component="h6" style={{ fontWeight: 600, fontSize: 16, textAlign: align }}>
          {label}
        </Typography>
      </Grid>
      <Grid item xs={6} md={12}>
        <Typography
          variant="body1"
          component="p"
          style={{ whiteSpace: 'break-spaces', fontSize: 14, textAlign: align }}
        >
          {value}
        </Typography>
      </Grid>
    </Grid>
  );
};

export default InformationField;
